import { useContext, useState } from "react";
import { Avatar, Box, CircularProgress, Container, CssBaseline, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Toolbar, Typography } from "@mui/material";
import { Business as BusinessIcon, ArrowForward as ArrowForwardIcon } from "@mui/icons-material"
import { useQuery, useQueryClient } from "react-query";
import { getBranchOfficesByUser, getCompaniesByUser } from "./services/api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { ActionFabButtonAdd, ActionsDialogPage } from "./ActionsPage";
import { useTranslation } from "react-i18next";
import { SnackbarGlobal } from "components/Snackbar";

export default function Account() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const { toogleBranchOffice } = useContext(AuthContext)
  const user = JSON.parse(localStorage.getItem('mqadusr'))
  const { data: usrC } = useQuery(
    ['companiesByUser', user._id], () => getCompaniesByUser(user._id),
    { refetchOnWindowFocus: false, enabled: user.role.identifier === "SUPERADMIN" }
  )
  const { data: usrBO } = useQuery(
    ['branchOfficesByUser', user._id], () => getBranchOfficesByUser(user._id),
    { refetchOnWindowFocus: false, enabled: user.role.identifier !== "SUPERADMIN" }
  )
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [instanceSelected, setInstanceSelected] = useState({})
  const queryClient = useQueryClient()

  const handleSelectCompany = (company) => {
    toogleBranchOffice(null)
    const user = JSON.parse(localStorage.getItem('mqadusr'))
    user.company = company
    localStorage.setItem('mqadusr', JSON.stringify(user))
    navigate("/admin/dashboard")
  }

  const handleSelectBranchOffice = (branchOffice) => {
    toogleBranchOffice(branchOffice)
    const user = JSON.parse(localStorage.getItem('mqadusr'))
    user.company = branchOffice.company
    localStorage.setItem('mqadusr', JSON.stringify(user))
    navigate("/admin/dashboard")
  }

  const handleRefreshData = () => { queryClient.invalidateQueries('companiesByUser') }
  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); handleRefreshData() }
  }

  return (
    <>
      <CssBaseline />
      <Box component="main">
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Paper className="peperdashboard" sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="h6" component="p">
              {user.role.identifier === "SUPERADMIN" ? "Selecciona una empresa" : "Selecciona una sucursal"}
            </Typography>
            <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
            {usrC !== undefined ?
              <List sx={{ width: '100%', bgcolor: '#F3F4F6', margin: "0 auto" }}>
                {usrC.data.map((company, index) => (
                  <ListItem
                    key={`${index}-${company._id}`}
                    secondaryAction={
                      <IconButton edge="end" aria-label="next" onClick={() => handleSelectCompany(company)}>
                        <ArrowForwardIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <BusinessIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={company.name} />
                  </ListItem>
                ))}
              </List>
              : null}

            {usrBO !== undefined ?
              <List sx={{ width: '100%', bgcolor: '#F3F4F6', margin: "0 auto" }}>
                {usrBO.data.map((branchOffice, index) => (
                  <ListItem
                    key={`${index}-${branchOffice._id}`}
                    secondaryAction={
                      <IconButton edge="end" aria-label="next" onClick={() => handleSelectBranchOffice(branchOffice)}>
                        <ArrowForwardIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <BusinessIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={branchOffice.name} />
                  </ListItem>
                ))}
              </List>
              : null}

          </Paper>
        </Container>
      </Box>
      {user.role.identifier === "SUPERADMIN" ? <ActionFabButtonAdd t={t} action={() => setOpenAction(1)} /> : null}
      <ActionsDialogPage
        open={openAction}
        close={() => handleResetActions()}
        instance={instanceSelected}
        reportAction={handleWatchAction} />
      <SnackbarGlobal
        open={notification.open}
        close={() => setNotification({ open: false, message: "", severity: "" })}
        message={notification.message}
        severity={notification.severity} />
    </>
  )
}